import React, { useContext, useEffect, useState } from 'react'
import { IProjectModel, IWorkSpaceModal, ProjectTypeEnum, ThemeTypes } from '../../models/SharedModel';
import Service from '../../services';
import { toast } from 'react-toastify';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import { RoutesEnum } from '../../models/RoutesModel';
import { ProjectStatus } from '../../models/ProjectModel';
import WorkSpaceForm from '../shared/WorkSpaceForm';
import { getFromSession } from '../../helpers/GenericHelpers';
import WorkSpaceUserMappingForm from '../shared/WorkSpaceUserMappingForm';
import { ThemeContext } from '../../models/ThemeContext';

interface IWorkSpaceUserMappingModal {
  mapWorkSpaceAndUserModal: boolean;
  toggleMapWorkSpaceModal: () => void;
  selectedWorkSpace?:any;
  getWorkSpaces?:Function;
}

const WorkSpaceUserMappingModal = (props: IWorkSpaceUserMappingModal) => {

  const { mapWorkSpaceAndUserModal, toggleMapWorkSpaceModal, selectedWorkSpace , getWorkSpaces} = props;
  const [selectedOptions, setSelectedOptions] = useState<any>([]);
  const service = new Service();
  
  const mapUserAndWorkSpace = () =>{
    const data = {
     "workspace_id":selectedWorkSpace?.workspace_id,
     "list_of_users":selectedOptions?.map((ele:any) => ele?.value)
    }
    service.workspace_users_mapping(data).then((response:any)=>{
      toggleMapWorkSpaceModal();
        getWorkSpaces && getWorkSpaces();
        toast.success(response?.data)
    }).catch((error:any)=>{
        console.log(error)
        toast.error('Something went wrong')
    })
  }

  const { themeName } = useContext(ThemeContext);

  return (
    <Modal
      className={`project-modal map-workspace-modal ${themeName === ThemeTypes?.BLUE_THEME ? '' : 'dark-modal'}`}
      isOpen={mapWorkSpaceAndUserModal}
      toggle={toggleMapWorkSpaceModal}
    >
      <ModalHeader toggle={toggleMapWorkSpaceModal}>Map Users to WorkSpace</ModalHeader>
      <ModalBody>
            <WorkSpaceUserMappingForm 
            cancelWorkSpaceMapping={toggleMapWorkSpaceModal}
            setSelectedOptions={setSelectedOptions}
            selectedOptions={selectedOptions}
            mapUserAndWorkSpace={mapUserAndWorkSpace}
            />
      </ModalBody>
    </Modal>
  )
}

export default WorkSpaceUserMappingModal